import { LicenseGenerationSettingsComponent } from './license-generation-settings.component'
import { searchRoutes } from './license-generation-settings.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [LicenseGenerationSettingsComponent],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(searchRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [LicenseGenerationSettingsComponent],
})
export class LicenseGenerationSettingsModule {}
